import React, { createContext, useReducer } from 'react'

export const SET_PLANT_DATA = 'SET_PLANT_DATA'
export const UPDATE_CHANGE_SHIFTS_DATA = 'UPDATE_CHANGE_SHIFTS_DATA'
export const SET_SELECTED_SHIFTS_DATA = 'SET_SELECTED_SHIFTS_DATA'
export const SHOW_SHIFTS_FORM = 'SHOW_SHIFTS_FORM'
export const SET_SHIFTS_DATA = 'SET_SHIFTS_DATA'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_PLANT_DATA: {
      return { ...data, plants: payload.data }
    }
    case UPDATE_CHANGE_SHIFTS_DATA: {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return { ...data, data: tempData, showFormPopup: false }
    }
    case SET_SELECTED_SHIFTS_DATA: {
      return {
        ...data,
        selectedObject: payload.data,
        showFormPopup: payload?.showFormPopup,
      }
    }
    case SHOW_SHIFTS_FORM: {
      return {
        ...data,
        selectedObject: payload.data,
        showFormPopup: payload.showFormPopup,
      }
    }
    case SET_SHIFTS_DATA: {
      return { ...data, data: payload.data }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  plants: [],
  selectedObject: {},
  showFormPopup: false,
  data: [],
}

const ShiftStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <ShiftsContext.Provider value={[state, dispatch]}>
      {children}
    </ShiftsContext.Provider>
  )
}

export const ShiftsContext = createContext(initialState)
export default ShiftStore
